import { c as _c } from "react/compiler-runtime";
export function FormFooter(t0) {
  const $ = _c(6);
  const {
    onClick,
    buttonText
  } = t0;
  const handleClickNeedHelp = _temp;
  let t1;
  if ($[0] !== buttonText || $[1] !== onClick) {
    t1 = <button type="button" onClick={onClick} className="text-brand font-medium hover:text-brand-alt active:text-brand-alt transition-colors text-sm hover:underline">{buttonText}</button>;
    $[0] = buttonText;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" data-testid="intercom-launcher-custom-launcher" onClick={handleClickNeedHelp} className="text-brand font-medium hover:text-brand-alt active:text-brand-alt transition-colors text-sm hover:underline">Need help?</button>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex items-center gap-1 text-foreground-muted">{t1}•{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp() {
  window.open("https://www.home.works/contact", "_blank");
}